import fetch from "@mv/flow-shared-utils/functions/fetch";
import { handleErrors } from "@/utils/handle-errors";
import { NewTemplate, Template } from "@/interfaces/sdk-templates";

export const actions = {
  fetchTemplateCategories(context: any, { pageNumber, name }: { pageNumber: number; name?: string }) {
    let url = `core/api/templates/category/paginated?pageNumber=${pageNumber}&pageSize=10`;
    if (name) {
      url += `&name=${name}`;
    }
    return fetch(url)
      .then(handleErrors)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });
  },

  fetchTemplates(context: any, { pageNumber, query, modifier }: { pageNumber: number; query?: string; modifier?: string }) {
    let url = `core/api/templates/paginated?pageNumber=${pageNumber}&pageSize=10`;
    if (query) {
      const queryParameter = modifier === "template" ? "name" : "categoryName";
      url += `&${queryParameter}=${query}`;
    }

    return fetch(url)
      .then(handleErrors)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });
  },

  createTemplateCategory(context: any, { categoryName }: { categoryName: string }) {
    return fetch(`core/api/templates/category`, {
      method: `POST`,
      body: JSON.stringify({ name: categoryName }),
    })
      .then(handleErrors)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });
  },

  deleteTemplateCategory(context: any, { id }: { id: number }) {
    return fetch(`core/api/templates/category/${id}`, {
      method: "DELETE",
    })
      .then(handleErrors)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });
  },

  updateTemplateCategory(context: any, { id, name }: { id: number; name: string }) {
    return fetch(`core/api/templates/category/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ name }),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  loadTemplates(context: any, { pageNumber, categoryId, categoryName }: { pageNumber: number; categoryId?: number; categoryName?: string }) {
    let url = `core/api/templates/paginated?pageNumber=${pageNumber}&pageSize=10`;
    if (categoryId) {
      url += `&categoryId=${categoryId}`;
    }
    if (categoryName) {
      url += `&categoryName=${categoryName}`;
    }
    return fetch(url)
      .then(handleErrors)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });
  },

  createTemplate(context: any, { template }: { template: NewTemplate }) {
    const formdata = new FormData();
    formdata.append("categoryId", `${template.categoryId}`);
    formdata.append("description", template.description);
    formdata.append("file", template.file as Blob);
    formdata.append("name", template.name);

    return fetch(
      `core/api/templates/upload`,
      {
        method: "POST",
        body: formdata,
      },
      true
    )
      .then(handleErrors)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });
  },

  updateTemplate(context: any, { id, categoryId, description, name }: Template) {
    return fetch(`core/api/templates/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ categoryId, name, description }),
    })
      .then(handleErrors)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });
  },

  deleteTemplate(context: any, { id }: { id: number }) {
    return fetch(`core/api/templates/${id}`, {
      method: "DELETE",
    })
      .then(handleErrors)
      .then((data) => data)
      .catch((err) => {
        throw err;
      });
  },

  downloadTemplate(context: any, { id }: { id: number }) {
    return fetch(`core/api/templates/download/${id}`)
      .then(async (res: any) => {
        if (!res.ok) {
          res = await res.json();
          throw new Array(res.message);
        }
        return res.blob();
      })
      .then((res) => res)
      .catch((err) => {
        throw err;
      });
  },
};

export const fetchTemplateCategories = (pageNumber: number, name?: string) => ({ type: "fetchTemplateCategories", pageNumber, name });
export const fetchTemplates = (pageNumber: number, query?: string, modifier?: string) => ({
  type: "fetchTemplates",
  pageNumber,
  query,
  modifier,
});
export const createTemplateCategory = (categoryName: string) => ({ type: "createTemplateCategory", categoryName });
export const deleteTemplateCategory = (id: number) => ({ type: "deleteTemplateCategory", id });
export const updateTemplateCategory = (id: number, name: string) => ({ type: "updateTemplateCategory", id, name });
export const loadTemplates = (pageNumber: number, categoryId?: number, categoryName?: string) => ({
  type: "loadTemplates",
  pageNumber,
  categoryId,
  categoryName,
});
export const createTemplate = (template: NewTemplate) => ({ type: "createTemplate", template });
export const updateTemplate = (id: number, categoryId: number, description: string, name: string) => ({
  type: "updateTemplate",
  id,
  categoryId,
  description,
  name,
});
export const downloadTemplate = (id: number) => ({ type: "downloadTemplate", id });
export const deleteTemplate = (id: number) => ({ type: "deleteTemplate", id });
